var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 .577a2 2 0 012 0l5.794 3.346a2 2 0 011 1.732v6.69a2 2 0 01-1 1.732L10 17.423a2 2 0 01-2 0l-5.794-3.346a2 2 0 01-1-1.732v-6.69a2 2 0 011-1.732L8 .577z",
    fill: "#F3C110"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98 11.647h6.04a.201.201 0 00.195-.152c.462-1.847.512-2.007 1.371-3.838.072-.152-.066-.32-.23-.283-2.587.581-3.446.222-4.153-1.53-.071-.176-.34-.178-.42-.005-.79 1.718-2.159 2.1-4.105 1.572-.169-.046-.32.128-.246.286.842 1.793.895 1.965 1.353 3.798.023.089.103.152.195.152z",
    fill: "#fff"
  })));
}

export default SvgCrown;